import { useState } from 'react'
import { Clock, ClipboardList, BarChart3 } from 'lucide-react'
import OreCalendarioTab from './OreCalendarioTab'
import AllocazioneOreTab from './AllocazioneOreTab'
import RiepilogoOreTab from './RiepilogoOreTab'

interface Props {
  commessaId: string
  onToast: (msg: string, type: 'success' | 'error') => void
}

const TABS = [
  { key: 'calendario', label: 'Calendario Ore', icon: Clock },
  { key: 'allocazione', label: 'Allocazione', icon: ClipboardList },
  { key: 'riepilogo', label: 'Riepilogo', icon: BarChart3 },
]

export default function RendicontazionePanel({ commessaId, onToast }: Props) {
  const [activeTab, setActiveTab] = useState('calendario')

  return (
    <div className="space-y-4">
      {/* Tab bar */}
      <div className="flex border-b border-gray-200">
        {TABS.map(tab => {
          const Icon = tab.icon
          const isActive = activeTab === tab.key
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-primary-600 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          )
        })}
      </div>

      {/* Tab content */}
      {activeTab === 'calendario' && (
        <OreCalendarioTab commessaId={commessaId} onToast={onToast} />
      )}
      {activeTab === 'allocazione' && (
        <AllocazioneOreTab commessaId={commessaId} onToast={onToast} />
      )}
      {activeTab === 'riepilogo' && (
        <RiepilogoOreTab commessaId={commessaId} onToast={onToast} />
      )}
    </div>
  )
}
